export default [ 'configService', 'storeService', 'prompt', '$window', function (configService, storeService, prompt, $window) {
  let getConfig = () => {
    if (!this.config) {
      this.config = configService.get('login');
    }
  };

  let login = (passwordOnly = false) => {
    return new Promise(resolve => {
      if (!isLoggedIn()) {
        getConfig();
        removeReservationData();
        return prompt.openLoginPrompt('Log in', this.config.text, passwordOnly)
          .then(response => {
            resolve(response);
          });
      }

      resolve(true);
    });
  };

  let logout = () => {
    if (isLoggedIn()) {
      return new Promise(resolve => {
        return prompt.openLogoutPrompt('Log out')
          .then(response => {
            resolve(response);
          });
      });
    }
  };

  let isLoggedIn = () => {
    return !!storeService.get('client_id');
  };

  let isAllowed = () => {
    getConfig();
    return !!this.config.allowed && !storeService.get('reservation');
  };

  let isRequired = () => {
    getConfig();
    return !!this.config.required;
  };

  let canRegister = () => {
    getConfig();
    return !!this.config.canRegister;
  };

  let stopEditing = () => {
    return new Promise(resolve => {
      if (isEditing()) {
        return prompt.openStopReservationPrompt('Logout')
          .then(response => {
            resolve(response);
          });
      }

      resolve(true);
    });
  };

  let removeReservationData = () => {
    if (isEditing()) {
      storeService.remove('reservation');
      storeService.remove('client_name');
      storeService.remove('start_date');
      storeService.remove('end_date');

      $window.dispatchEvent(new CustomEvent('initCalendar'));
    }
  };

  let isEditing = () => {
    return !!storeService.get('reservation');
  };

  return {
    login,
    logout,
    isLoggedIn,
    isAllowed,
    isRequired,
    canRegister,
    stopEditing,
    removeReservationData,
    isEditing
  };
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/services/loginout.service.js